const APP_MODES = ['writer', 'agent'];

export const getAppModeFromPath = (pathname) => {
  const segment = String(pathname || '').split('/').filter(Boolean)[0];
  return APP_MODES.includes(segment) ? segment : null;
};

export const stripAppModeFromPath = (pathname) => {
  const mode = getAppModeFromPath(pathname);
  if (!mode) return pathname || '/';
  const stripped = String(pathname || '').replace(`/${mode}`, '');
  return stripped || '/';
};

export const inferAppModeFromPath = (pathname) => {
  const normalized = stripAppModeFromPath(pathname);
  if (
    normalized === '/assistants' ||
    normalized.startsWith('/chat') ||
    normalized.startsWith('/ai-agents') ||
    normalized.startsWith('/crm')
  ) {
    return 'agent';
  }
  return 'writer';
};

export const withAppModePath = (mode, path) => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `/${mode}${normalized}`;
};

export const APP_MODE_VALUES = APP_MODES;

// Super admin analytics lives outside the writer/agent modes: no mode sidebar,
// its own layout (pages/Admin/AdminLayout.js), reachable with an expired trial.
export const ADMIN_BASE_PATH = '/admin';

export const isAdminPath = (pathname) => {
  const path = String(pathname || '');
  return path === ADMIN_BASE_PATH || path.startsWith(`${ADMIN_BASE_PATH}/`);
};
